import React, { Component } from 'react';
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import Helmet from "react-helmet"
import Header from "./header"
import Footer from "./app/footer/Footer"
import Transition from "./gatsby/transition"
import BackToTop from "./wwc/media/BackToTop/BackToTop"
import "./layout.css"

import GatsbyImage from './gatsby/image';
import Button from './wwc/ui/Button/Button';
import Cookies from 'js-cookie';
import MsalConnect from './msal';

const LocaleContext = React.createContext()

class Layout extends Component {

  constructor(props) {  
    super(props);
    this.state = { accessToken: undefined };
  }

  handleClick = e => {
    var msal = new MsalConnect();
    msal.login().then(response => {
      if(response.uniqueId) {
        this.setState({'accessToken' : response.uniqueId});
      }
    })  
  };

  componentDidMount(){
    const cookie = Cookies.get('uniqueId');
    if(cookie && document.getElementById('sign-in')){
      document.getElementById('sign-in').removeAttribute('id');      
    }

    document.documentElement.classList.add('active');
  }

  render() {
    const { children, data, location, path, pageContext } = this.props;
    let site, header, footer, backToTop;
    if(data.siteJson)
    ({site, header, footer, backToTop } = data.siteJson);
    const { accessToken } = this.state;
    const cookie = Cookies.get('uniqueId');

    console.log('render : '+cookie);

    if(!cookie){
      return (
        <div id="sign-in">      
        <GatsbyImage imageName={"common/logo.svg"} />                
        <Button onClick={e => this.handleClick(e)} type="button" id="signIn" className="btn btn-secondary" style={{position: 'relative', zIndex:9000}}>Sign In</Button>
      </div>);
    } 

    return (
      <>
        <Helmet>
          <meta property="og:description" content={site.description} />
        </Helmet>
        <Header data={header} path={path} pageContext={pageContext} />    
        <Transition location={location}>
          <main role="main">{children}</main>
        </Transition>        
        <Footer data={footer} />
        <BackToTop data={backToTop} />
      </>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}


export { Layout, LocaleContext }


export const query = graphql`
  fragment SiteData on SiteJson {
    site {
      title
      description
      locale 
    },
    header {
      logo {
        image
        alt,
        label,
        url
      },
      right {
        label,
        url
      }
    },
    ...BackToTop
    footer {
      logo{
        image
        alt
      }
      items {
        icon,
        body
      },
      copyright
    }
  }
`